import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["id", "value", "name", "className", "checked", "required", "disabled", "onChange", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import React from 'react';
import Button from '@/components/Button';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const RadioButtonItem = _ref => {
  let {
    id: optionId,
    value,
    name,
    className,
    checked = false,
    required,
    disabled = false,
    onChange = () => null,
    children
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs("label", _objectSpread(_objectSpread({}, optionId && {
    htmlFor: optionId
  }), {}, {
    className: clsx(styles.label, className || ''),
    children: [/*#__PURE__*/_jsx("input", _objectSpread(_objectSpread({}, optionId && {
      id: optionId
    }), {}, {
      type: "radio",
      name: name,
      value: value,
      onChange: onChange,
      defaultChecked: checked,
      className: styles.radioInput
    }, required && {
      required: true
    })), /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({}, props), {}, {
      className: styles.button,
      variant: checked ? 'primary' : 'tertiary',
      disabled: disabled,
      type: "button",
      tabIndex: -1,
      children: children
    }))]
  }));
};

export default RadioButtonItem;